import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import { useParams, useNavigate } from "react-router-dom";
import Axios from "axios";
import { useSelector, useDispatch } from "react-redux";

//STYLES
import * as HomeStyles from "../styles/home";

//COMPONENTS
import NewTask from "./newTask";
import TaskCard from "./taskCard";
import TaskDetails from "./taskDetails";

import * as PlannerActions from "../../../../envStore/actions/planner";

function Home() {
    const params = useParams();
    const bodyRef = useRef(null);
    const [bodyHeight, setBodyHeight] = useState("100vh");
    const [columnHeight, setColumnHeight] = useState("300px");

    const user = useSelector((state) => state.user);
    const planner = useSelector((state) => state.planner);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    //TASKS
    const [notStarted, setNotStarted] = useState([]);
    const [inProgress, setInProgress] = useState([]);
    const [toBeTested, setToBeTested] = useState([]);
    const [completed, setCompleted] = useState([]);

    const [planDetails, setPlanDetails] = useState({
        title: ""
    });

    const [newTaskModal, setNewTaskModal] = useState({
        open: false
    });

    function handleCloseNewTaskModal() {
        setNewTaskModal((prevState) => {
            return { ...prevState, open: false };
        });
    }

    function handleOpenNewTaskModal() {
        setNewTaskModal((prevState) => {
            return { ...prevState, open: true };
        });
    }

    const [taskDeatilsModal, setTaskDetailsModal] = useState({
        open: false,
        uuid: ""
    });

    function handleOpenTaskDetailsModal(uuid) {
        setTaskDetailsModal((prevState) => {
            return { ...prevState, uuid: uuid, open: true };
        });
    }

    function handleCloseTaskDetailsModal() {
        setTaskDetailsModal((prevState) => {
            return { ...prevState, open: false };
        });
    }

    useEffect(() => {
        loadPlan();

        setBodyHeight(bodyRef.current.offsetHeight - 60);
        setColumnHeight(bodyRef.current.offsetHeight - 210);
    }, []);

    function loadPlan() {
        const data = { uuid: params.id, userID: user.id };
        Axios.post("/pods/plannerTasks/getPlanDetails", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setPlanDetails((prevState) => {
                        return { ...prevState, title: data.planDetails.title };
                    });
                    dispatch(PlannerActions.UpdateType(data.userDetails.type));

                    setNotStarted(data.tasks.filter((task) => task.state == "Not Started"));
                    setInProgress(data.tasks.filter((task) => task.state.includes("In Progress")));
                    setToBeTested(data.tasks.filter((task) => task.state == "To Be Tested"));
                    setCompleted(data.tasks.filter((task) => task.state == "Completed"));
                } else {
                    navigate("../");
                }
            })
            .catch((err) => console.log(err));
    }

    return (
        <div ref={bodyRef} style={{ ...HomeStyles.body, height: bodyHeight }}>
            <div style={HomeStyles.heading}>
                <h1 style={planDetails.title != "" ? HomeStyles.titleVisible : HomeStyles.titleHidden}>
                    <u>Plan - {planDetails.title}</u>
                </h1>
            </div>
            {(planner.type == "admin" || planner.type == "contractor") && (
                <div style={HomeStyles.addNewTaskRow}>
                    <OverlayTrigger placement="right" overlay={<Tooltip>New Task</Tooltip>}>
                        <Button onClick={handleOpenNewTaskModal}>
                            <i className="fa-solid fa-plus"></i>
                        </Button>
                    </OverlayTrigger>
                </div>
            )}

            <div style={HomeStyles.statusTitlesRow}>
                <Row>
                    <Col sm={3} style={HomeStyles.statusTitles}>
                        Not Started
                    </Col>
                    <Col sm={3} style={HomeStyles.statusTitles}>
                        In Progress
                    </Col>
                    <Col sm={3} style={HomeStyles.statusTitles}>
                        To Be Tested
                    </Col>
                    <Col sm={3} style={HomeStyles.statusEndTitle}>
                        Completed
                    </Col>
                </Row>
                <br />
            </div>
            <div style={HomeStyles.taskColumns}>
                <Row style={HomeStyles.plansRowHeight}>
                    <Col sm={3} style={{ ...HomeStyles.planColumns, height: columnHeight }}>
                        {notStarted.map((task, index) => {
                            return (
                                <div key={index}>
                                    <TaskCard task={task} onOpen={handleOpenTaskDetailsModal.bind(this, task.uuid)} />
                                    <br />
                                </div>
                            );
                        })}
                    </Col>
                    <Col sm={3} style={{ ...HomeStyles.planColumns, height: columnHeight }}>
                        {inProgress.map((task, index) => {
                            return (
                                <div key={index}>
                                    <TaskCard task={task} onOpen={handleOpenTaskDetailsModal.bind(this, task.uuid)} />
                                    <br />
                                </div>
                            );
                        })}
                    </Col>
                    <Col sm={3} style={{ ...HomeStyles.planColumns, height: columnHeight }}>
                        {toBeTested.map((task, index) => {
                            return (
                                <div key={index}>
                                    <TaskCard task={task} onOpen={handleOpenTaskDetailsModal.bind(this, task.uuid)} />
                                    <br />
                                </div>
                            );
                        })}
                    </Col>
                    <Col sm={3} style={{ ...HomeStyles.planColumns, height: columnHeight }}>
                        {completed.map((task, index) => {
                            return (
                                <div key={index}>
                                    <TaskCard task={task} onOpen={handleOpenTaskDetailsModal.bind(this, task.uuid)} />
                                    <br />
                                </div>
                            );
                        })}
                    </Col>
                </Row>
            </div>
            <NewTask open={newTaskModal.open} close={handleCloseNewTaskModal} planUUID={params.id} loadPlan={loadPlan} />
            <TaskDetails open={taskDeatilsModal.open} close={handleCloseTaskDetailsModal} uuid={taskDeatilsModal.uuid} loadPlan={loadPlan} />
        </div>
    );
}

export default Home;
